import InternalLinks from './InternalLinksGC';

export default InternalLinks;
